import type { JSX } from "react"
// to help with typing the containers, use this:
export type ModalContainerComponent = {
    (): JSX.Element
    mappedName: string
}

export enum EmailShareTypeNames {
    LiveStream = "LiveStream",
    MultiStream = "MultiStream",
}

export enum ModalNames {
    OrganizationEditorModal = "OrganizationEditorModal",
    DecisionModal = "DecisionModal",
    MapIconLabelModal = "MapIconLabelModal",
    InviteEverywhereModal = "InviteEverywhereModal",
    WorkspaceConfirmationModal = "WorkspaceConfirmationModal",
    WorkspaceAccessModal = "WorkspaceAccessModal",
    ExportLayersModal = "ExportLayersModal",
    RequestAccessModal = "RequestAccessModal",
    AssignSubscriptionsModal = "AssignSubscriptionsModal",
    LicenseCheckoutModal = "LicenseCheckoutModal",
    ActivateKeyModal = "ActivateKeyModal",
    AddOnPaywallModal = "AddOnPaywallModal",
    LicenseUpgradeModal = "LicenseUpgradeModal",
    LicensePaywallModal = "LicensePaywallModal",
    PaymentSuccessModal = "PaymentSuccessModal",
    LiveVideoTutorialModal = "LiveVideoTutorialModal",
    UnarchiveLayers = "UnarchiveLayers",
    /** @deprecated */
    WelcomeToNovaModal = "WelcomeToNovaModal",
    TAKAuthModal = "TAKAuthModal",
    CalTopoAuthModal = "CalTopoAuthModal",
    WelcomeTryOrthomosaicsModal = "WelcomeTryOrthomosaicsModal",
    TryOurAddOnsModal = "TryOurAddOnsModal",
    TryOrthomosaicsModal = "TryOrthomosaicsModal",
    TryHotspotsModal = "TryHotspotsModal",
    TryColorfinderModal = "TryColorfinderModal",
    TryLiveVideoModal = "TryLiveVideoModal",
    TryVideoModal = "TryVideoModal",
    TryPanoramaModal = "TryPanoramaModal",
    ScreenSizeAlertModal = "ScreenSizeAlertModal",
    BrowserAlertModal = "BrowserAlertModal",
    ChooseLiveVideoTypeModal = "ChooseLiveVideoTypeModal",
    LiveVideoMobileModal = "LiveVideoMobileModal",
    DjiEnterpriseOcaModal = "DjiEnterpriseOcaModal",
    UserProfileModal = "UserProfileModal",
    SkydioLiveStreamModal = "SkydioLiveStreamModal",
    FlirMmaLiveStreamModal = "FlirMmaLiveStreamModal",
    FeatureFlagToggleModal = "FeatureFlagToggleModal",
}
